var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPackageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838F",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M16 28V17.333M16 28l-9.727-6.08c-.46-.286-.689-.43-.814-.656-.126-.226-.126-.497-.126-1.04v-9.557M16 28l5.333-3.333 4.394-2.746c.46-.287.689-.431.814-.657.126-.226.126-.497.126-1.04v-9.557M16 17.333 5.333 10.667M16 17.333l10.667-6.666m-21.334 0 9.607-6.004c.515-.323.773-.484 1.06-.484s.544.161 1.06.483l9.607 6.005"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#77838F",
  d: "M20.333 19.336a1 1 0 1 0 2 0h-2m.06-5.92-.53.847zm.815.656-.875.485zM10.667 7.336l-.53.848 9.726 6.08.53-.849.53-.848-9.726-6.08zm10.666 12h1V15.11h-2v4.225zm-.94-5.92-.53.847c.246.154.37.233.455.297.067.051.042.045.015-.003l.875-.485.875-.485a2 2 0 0 0-.549-.614c-.177-.136-.397-.272-.61-.406zm.94 1.695h1c0-.252.001-.51-.02-.733a2 2 0 0 0-.23-.79l-.875.484-.875.485c-.027-.049-.019-.073-.01.011.01.106.01.253.01.543z"
})));
export default SvgPackageIcon;